import { __cAuthService } from '@/services/client/__c.auth.service'
import { TVerifyOtpParams } from '@/types/auth'
import { useMutation } from '@tanstack/react-query'

export const useVerifyOtpMutation = () => {
  return useMutation({
    mutationFn: async (body: TVerifyOtpParams) => {
      const response = await __cAuthService.verifyOtp(body)
      return response
    },
  })
}
